import React from 'react';
import { PRODUCT_INTEL } from '../data/constants.js';
import type { ProductPlatform, ProductIntel as ProductIntelType } from '../data/constants.js';
import './product-intel.css';

const PLATFORM_CSS: Record<ProductPlatform, string> = {
  WEB: 'web',
  iOS: 'ios',
  visionOS: 'vision-os',
};

interface ProductIntelProps {
  products?: ProductIntelType[];
  activeProcedures?: number;
  loading?: boolean;
}

export function ProductIntel({
  products,
  activeProcedures,
  loading,
}: ProductIntelProps): React.ReactElement {
  const data = products ?? PRODUCT_INTEL;
  return (
    <div className="mc-product-intel">
      {data.map((product, index) => (
        <div key={product.name} className="mc-product-intel__section">
          <div className="mc-product-intel__header">
            <span className="mc-product-intel__name">{product.name}</span>
            <span
              className={`mc-product-intel__badge mc-product-intel__badge--${PLATFORM_CSS[product.platform]}`}
            >
              {product.platform}
            </span>
          </div>
          <div className="mc-product-intel__rows">
            {product.items.map((item) => (
              <div key={item.label} className="mc-product-intel__row">
                <span className="mc-product-intel__label">{item.label}</span>
                <span className="mc-product-intel__value">{item.value}</span>
              </div>
            ))}
            {product.name.replace(/\s+/g, '').toLowerCase() === 'viewerx' && (
              <div className="mc-product-intel__row">
                <span className="mc-product-intel__label">Active Procedures</span>
                <span
                  className={`mc-product-intel__value mc-product-intel__value--live${loading ? ' loading-blur' : ''}`}
                >
                  {activeProcedures ?? 0}
                </span>
              </div>
            )}
          </div>
          {index < data.length - 1 && <div className="mc-product-intel__divider" />}
        </div>
      ))}
    </div>
  );
}
